const checkIfCustomPadding = (value) => {
    const spacingScales = ['3X', '4X', '6X', '8X', '12X'];
    return !spacingScales.includes(value);
};

export { checkIfCustomPadding };
